import SkillRenderer from "../../view/canvas/SkillRenderer";
import PartyCharacter from "../character/PartyCharacter";
import BigNum from "../math/BigNum";
import NumberValue from "../value/NumberValue";
import SkillNode from "./SkillNode";
import SkillNodePurchaseListener from "./SkillNodePurchaseListener";

export default class SkillType extends SkillNodePurchaseListener {
    /**
     * @abstract
     * @param {string} id
     */
    constructor(id) {
        super();

        /**
         * @constant
         * @type {string}
         */
        this.id = id;

        /**
         * @type {SkillNode}
         */
        this.rootNode = null;

        /**
         * @type {SkillNode[]}
         */
        this.nodes = [];

        /**
         * @type {boolean}
         */
        this.unlocked = false;

        /**
         * @constant
         * @type {NumberValue}
         */
        this.durationUpgrades = new NumberValue(null, 0);
        /**
         * @constant
         * @type {NumberValue}
         */
        this.coolDownUpgrades = new NumberValue(null, 0);

        /**
         * Keep track of how many points have been spent on this skill so that we can support reset.
         * @constant
         * @type {BigNum}
         */
        this.pointsSpent = new BigNum(0);
    }

    /**
     * @param {SkillNode} node 
     * @returns {SkillNode}
     */
    addNode(node) {
        if (!this.rootNode) {
            this.rootNode = node;
        }
        this.nodes.push(node);

        return node;
    }

    /**
     * @returns {SkillNode}
     */
    getRootNode() {
        return this.rootNode;
    }

    /**
     * @returns {boolean}
     */
    isUnlocked() {
        return this.unlocked;
    }

    /**
     * @abstract
     * @returns {SkillRenderer}
     */
    getRenderer() {
        return null;
    }

    /**
     * @abstract
     * @param {PartyCharacter} miner
     * @param {number} frameTimeRatio 
     * @param {boolean} skillActive
     */
    updateSkillForFrame(miner, frameTimeRatio, skillActive) {
    }

    /**
     * @param {string} id 
     * @returns {SkillNode}
     */
    getSkillNodeById(id) {
        for (let i = 0; i < this.nodes.length; i++) {
            const skillNode = this.nodes[i];
            if (id === skillNode.id) {
                return skillNode;
            }
        }
        return null;
    }

    onSaveLoad() {
        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].onSaveLoad();
        }
    }

    ////////////////////////////////////
    // SkillNodePurchaseListener
    ////////////////////////////////////

    /**
     * Invoked by the skill node when it is purchased.
     * @param {BigNum} pointsSpent
     * @override
     */
    onNodePurchased(pointsSpent) {
        this.unlocked = true;
        this.pointsSpent.add(pointsSpent);
    }

    /**
     * @override
     */
    onNodePurchasedFromSave() {
        this.unlocked = true;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.unlocked = false;
        this.pointsSpent.setZero();

        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].resetFull();
        }

        this.coolDownUpgrades.reset();
        this.durationUpgrades.reset();
    }

    /**
     * @override
     */
    resetForPrestige() {
        // Skills are not reset on prestige.
    }   
}